import React, { useRef } from "react";
import "./FloodgatePreview.css";
import ColorParse from "../ColorParse";

export default function FloodgatePreview({ config, setConfig, selectedItem }) {
  const containerRef = useRef(null);

  const renderItem = (item, key) => {
    if (!item || typeof item !== "object") return null;
    const { type } = item;

    switch (type) {
      case "input":
        return (
          <React.Fragment key={key}>
            <div key={key + "-text"} className="floodgate-text input">
              {ColorParse(item?.name ?? "")}
            </div>
            <div key={key + "-input"} className="floodgate-button input">
              {ColorParse(item?.placeholder ?? "Type Here...")}
            </div>
          </React.Fragment>
        );

      case "label":
        return (
          <React.Fragment key={key}>
            <div key={key + "-text"} className="floodgate-text input">
              {ColorParse(item?.name ?? "")}
            </div>
          </React.Fragment>
        );

      case "dropdown":
        return (
          <React.Fragment key={key}>
            <div key={key + "-text"} className="floodgate-text input">
              {ColorParse(item?.name ?? "")}
            </div>
            <div key={key} className="floodgate-button dropdown">
              {ColorParse(item?.options?.[0] ?? "None")}
            </div>
          </React.Fragment>
        );

      case "slider":
        return (
          <React.Fragment key={key}>
            <div key={key + "-text"} className="floodgate-text input">
              {ColorParse(item?.name ?? "")}: {item?.default ?? 0}
            </div>
            <div key={key} className="floodgate-button slider"></div>
          </React.Fragment>
        );

      case "step-slider":
        return (
          <React.Fragment key={key}>
            <div key={key + "-text"} className="floodgate-text input">
              {ColorParse(item?.name ?? "")}: {ColorParse(item?.steps?.[0] ?? "None")}
            </div>
            <div key={key} className="floodgate-button slider"></div>
          </React.Fragment>
        );

      case "toggle":
        return (
          <React.Fragment key={key}>
            <div key={key + "-text"} className="floodgate-text input">
              {ColorParse(item?.name ?? "")}
            </div>
            <div key={key} className="floodgate-button toggle"></div>
          </React.Fragment>
        );

      case "button":
      default:
        const hasIcon = !!item["icon-texture"];
        return (
          <div
            key={key}
            className={`floodgate-button${hasIcon ? " icon" : ""}`}
          >
            {ColorParse(item?.name ?? "")}
          </div>
        );
    }
  };

  const layoutKeys = Object.keys(config?.layout ?? {}).sort((a, b) => parseInt(a) - parseInt(b));
  const rawOrderedItems = layoutKeys.map((key) => {
    const itemKeys = config?.layout?.[key] ?? [];
    const firstKey = itemKeys[0];
    return config?.items?.[firstKey];
  }).filter(Boolean);

  const buttonItems = [];
  const inputItems = [];

  for (const item of rawOrderedItems) {
    if (!item || typeof item !== "object") continue;

    if (!item.type || item.type === "button") {
      buttonItems.push(item);
    } else {
      inputItems.push(item);
    }
  }

  const orderedItems = config?.["floodgate-type"] === "custom"
    ? [...inputItems, { type: "button", name: "Submit" }]
    : buttonItems;

  // Function to parse subtitle with new lines
  const renderSubtitle = () => {
    if (
      config?.subtitle &&
      config["floodgate-type"] === "simple"
    ) {
      const lines = config.subtitle.split("\\n");
      return (
        <div className="floodgate-text subtitle">
          {lines.map((line, index) => (
            <div key={index}>{ColorParse(line)}</div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="floodgate-panel" ref={containerRef}>
      {renderSubtitle()}
      <div className="floodgate-body">
        {orderedItems.map((item, index) => renderItem(item, index))}
      </div>
    </div>
  );
}
